import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { tap } from 'rxjs/operators';
import { CmsPuffCollectionComponent } from '../../../core/model';
@Component({
  selector: 'py-puff-collection',
  templateUrl: './puff-collection.component.html',
  styleUrls: ['./puff-collection.component.scss'],
  standalone: false,
})
export class PuffCollectionComponent implements OnInit {
  puffUids: string[] = [];
  styleClasses: string;

  constructor(
    public cmsComponent: CmsComponentData<CmsPuffCollectionComponent>,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cmsComponent.data$ = this.cmsComponent.data$.pipe(
      tap((data) => (this.styleClasses = data?.styleClasses || 'puff-collection-default-list'))
    );
  }

  onSetPuffUids(puffUids) {
    this.puffUids = puffUids;
    this.cd.detectChanges();
  }
}
